module.exports = __webpack_public_path__ + "img/trash.6fb081c5.svg";